import WeeklyRevenue from "./components/WeeklyRevenue";
import TotalSpent from "./components/TotalSpent";
import Step from "./components/Step";
import { useEffect, useRef, useState } from "react";
import Pdf1 from "../../../assets/Docs/POSP_Training.pdf";
import Pdf2 from "../../../assets/Docs/POSP_Certificate.pdf";
import axios from "axios";
import { BASE_URL } from "../../../baseurl";
import { number } from "yup";

const Dashboard = () => {
  const [steps, setSteps] = useState([]);

  const [currentVideo, setCurrentVideo] = useState(0);
  const videoRef = useRef();
  const timeRef = useRef(0);

  const changeActive = (id) => {
    if (steps?.[id - 1]?.active) {
      setCurrentVideo(id != 0 ? id - 1 : currentVideo);
    }
  };

  const videoIsComplete = (id) => {
    setSteps((prevSteps) => {
      return prevSteps.map((step, index) => {
        if (index === id) {
          return { ...step, completed: true };
        } else if (index === id + 1) {
          return { ...step, active: true };
        } else {
          return step;
        }
      });
    });
    setCurrentVideo((pre) => (steps.length != pre ? pre + 1 : pre));
    setVideoCount(
      steps.length !== currentVideo ? currentVideo + 1 : currentVideo
    );
    console.log(
      steps.length != currentVideo ? currentVideo + 1 : currentVideo,
      "checkdata--->>>"
    );
  };

  const handleSeeked = () => {
    if (!steps?.[currentVideo]?.completed) {
      if (timeRef.current < videoRef.current.currentTime) {
        videoRef.current.currentTime = timeRef.current;
      }
    }
  };

  const setVideoCount = async (count) => {
    try {
      let token = localStorage.getItem("user_token");
      let res = await axios.post(
        `${BASE_URL}/video/updateCount`,
        {
          videoCount: count,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      let videoCount = res.data?.videoCount || 1;
      setSteps((prevSteps) => {
        return prevSteps.map((step, index) => {
          if (index <= Number(videoCount) - 1) {
            return { ...step, completed: true, active: true };
          } else if (index === Number(videoCount)) {
            return { ...step, active: true };
          } else {
            return step;
          }
        });
      });

      if (res.status == 200) {
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getVideoCount = async (resData) => {
    try {
      let token = localStorage.getItem("user_token");
      let res = await axios.get(`${BASE_URL}/user/video/getVideoCount`, {
        headers: {
          Authorization: token,
        },
      });
      console.log(res, "checkvideocount");
      let videoCount = res.data?.data?.videoCount;
      setSteps((prevSteps) => {
        return prevSteps.map((step, index) => {
          console.log(step, index, videoCount, "cehckvideocount");
          if (index <= Number(videoCount) - 2) {
            return { ...step, completed: true, active: true };
          } else if (videoCount != 1 && index === Number(videoCount) - 1) {
            return Number(videoCount) != resData?.length
              ? { ...step, active: true }
              : { ...step, active: true, completed: true };
          } else {
            return step;
          }
        });
      });

      setCurrentVideo(Number(videoCount) - 1);

      if (res.status == 200) {
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getVideo = async () => {
    try {
      let token = localStorage.getItem("user_token");
      let res = await axios.get(`${BASE_URL}/user/video/getAllVideo`, {
        headers: {
          Authorization: token,
        },
      });
      console.log(res, "checkresponse");

      function transformData(inputData) {
        return inputData.map((item, index) => ({
          id: index + 1,
          title: item.fileName,
          active: index === 0, // Set the first item as active
          path: item.fileUrl,
          completed: false,
        }));
      }

      setSteps(transformData(res?.data?.data));

      if (res.status == 200) {
        getVideoCount(res?.data?.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getVideo();
  }, []);

  console.log(steps, "checkseeking");

  return (
    <div>
      <div className="container pt-[40px] m-auto bg_kyc">
        <div className=" rounded-xl md:p-3 md:flex justify-center w-[100%] mt-[50px]">
          <div className="relative form_sidebar ">
            <div className="text-black w-full flex flex-col gap-2 p-4">
              {steps.map((step, index) => (
                <Step
                  key={step.id}
                  number={step.id}
                  title={step.title}
                  active={step.active}
                  completed={step.completed}
                  changeActive={changeActive}
                />
              ))}
            </div>
          </div>

          <div className="flex flex-col justify-between absolute top-40 w-[450px] md:static mb-40 rounded-2xl pt-[40px] pl-[20px] pr-[20px] w-[50%] h-[565px] shadow_form  rounded-tl-none rounded-bl-none rounded-tr-lg rounded-br-lg bg-white overflow-y-auto">
            <>
              <div>
                {/* <TotalSpent paf={currentPdf} /> */}

                <video
                  className="w-full"
                  controls
                  ref={videoRef}
                  src={steps?.[currentVideo]?.path}
                  onEnded={() =>
                    !videoRef?.current?.seeking && videoIsComplete(currentVideo)
                  }
                  type="video/mp4"
                  onSeeking={handleSeeked}
                  onTimeUpdate={(e) => {
                    if (
                      !videoRef?.current?.seeking &&
                      !steps?.[currentVideo]?.completed
                    ) {
                      timeRef.current < videoRef.current.currentTime &&
                        (timeRef.current = videoRef.current.currentTime);
                    }
                  }}
                >
                  Your browser does not support the video tag.
                </video>

                <h2 className="text-2xl mt-4">
                  {steps?.[currentVideo]?.title}
                </h2>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
